"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hfround = require("./hfround");

Object.defineProperty(exports, "hfround", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_hfround).default;
  }
});

var _Float16Array = require("./Float16Array");

Object.defineProperty(exports, "Float16Array", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Float16Array).default;
  }
});

var _dataView = require("./dataView.js");

Object.defineProperty(exports, "getFloat16", {
  enumerable: true,
  get: function get() {
    return _dataView.getFloat16;
  }
});
Object.defineProperty(exports, "setFloat16", {
  enumerable: true,
  get: function get() {
    return _dataView.setFloat16;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@petamoriken/float16/lib/index.js
// module id = 96
// module chunks = 0